import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const PopUpIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="21"
      viewBox="0 0 20 21"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11.688 3.625a.5.5 0 0 1 .5-.5h4.686a.5.5 0 0 1 .5.5l.001 4.687a.5.5 0 0 1-1 0v-3.48L11.6 9.607a.5.5 0 1 1-.707-.707l4.773-4.774h-3.48a.5.5 0 0 1-.5-.5Zm-7.938 3a.125.125 0 0 0-.125.125v10a.125.125 0 0 0 .125.125h10a.125.125 0 0 0 .125-.125v-5a.5.5 0 0 1 1 0v5a1.125 1.125 0 0 1-1.125 1.125h-10a1.125 1.125 0 0 1-1.125-1.125v-10A1.125 1.125 0 0 1 3.75 5.625h5a.5.5 0 0 1 0 1h-5Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
